function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.628906 32.2766L44.3297 1H303.085L320.606 13.5395H339.361L353.458 23.6287V399.411H204.432L176.439 419.445H44.3297L14.3232 397.969H0.628906V32.2766Z",
  fill: "url(#paint10_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.628906 32.2766L44.3297 1H303.085L320.606 13.5395H339.361L353.458 23.6287V399.411H204.432L176.439 419.445H44.3297L14.3232 397.969H0.628906V32.2766Z",
  stroke: "#FF15BD",
  strokeWidth: 0.56862,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.628906 32.2766L44.3297 1H303.085L320.606 13.5395H339.361L353.458 23.6287V399.411H204.432L176.439 419.445H44.3297L14.3232 397.969H0.628906V32.2766Z",
  stroke: "url(#paint11_linear)",
  strokeOpacity: 0.9,
  strokeWidth: 0.56862,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 0.721343,
  y1: 71.8821,
  x2: 353.429,
  y2: 71.8821,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#702AE3",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F3EB7",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 349.193,
  y1: 1.00004,
  x2: 56.1297,
  y2: -37.9048,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00393049,
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F71C1C"
})));

function SvgFeaturedContentBgSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 354 420",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedContentBgSmall);
export default __webpack_public_path__ + "static/media/featured-content-bg-small.73af1e4f.svg";
export { ForwardRef as ReactComponent };